import React from 'react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import { MessageDialogPopup } from '@sales-center/components'

type Props = {
  open: boolean
  isClearing: boolean
  onCancel: () => void
  onConfirm: () => void
}

// Shared confirm dialog for clearing the current knock status (SH-661). Thin wrapper over the
// existing MessageDialogPopup so the card, drawer, and all map bubbles render the exact same copy.
export function ClearKnockStatusConfirmDialog({
  open,
  isClearing,
  onCancel,
  onConfirm,
}: Props) {
  if (!open) return null
  return (
    <MessageDialogPopup
      open={open}
      title="Clear Knock Status"
      message={
        <Alert severity="warning">
          This will clear the current knock status and reason. Knock status
          history, notes, and the activity timeline will remain as is.
        </Alert>
      }
      cancelClick={onCancel}
      cancelButtonText="Cancel"
      cancelButtonVariant="text"
      actionButtons={[
        <Button
          key="clear-knock-status-btn"
          variant="contained"
          color="primary"
          onClick={onConfirm}
          disabled={isClearing}
        >
          Clear
        </Button>,
      ]}
      actionButtonsPlacement="end"
    />
  )
}
